export default "__VITE_ASSET__CnYfIP3g__"